import CleanMobileComponent from "../../../../src/events/2023/04/cleanMobile/main";
import * as React from 'react';
export default {
  CleanMobileComponent,
  React
};